import { render, staticRenderFns } from "./DatabaseMigrationBatch.vue?vue&type=template&id=4806d45d&"
import script from "./DatabaseMigrationBatch.vue?vue&type=script&lang=ts&"
export * from "./DatabaseMigrationBatch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports